import { render } from "./UpdateCase.vue?vue&type=template&id=1d11f8e0&scoped=true&ts=true"
import script from "./UpdateCase.vue?vue&type=script&lang=ts"
export * from "./UpdateCase.vue?vue&type=script&lang=ts"

import "./UpdateCase.vue?vue&type=style&index=0&id=1d11f8e0&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d11f8e0"]])

export default __exports__